import {
  faArrowRight as freeFasFaArrowRight
} from '@fortawesome/free-solid-svg-icons'

export default {freeFasFaArrowRight}